/* eslint-disable camelcase */
import { SORT_ORDER, TFilterOptions } from '@evinced-private/ui-common';

import omit from 'lodash-es/omit';
import { CUSTOM_FIELDS_FILTER_PARAM_KEY } from 'src/apps/dashboard/constants/CustomFields';
import { buildEnvironmentFilters } from 'src/apps/dashboard/services/queries/dashboard/helpers/environmentFilterBuilder';
import { IGetWebSdkTestsParams } from 'src/apps/dashboard/types/WebSdkDashboardServiceTypes';
import { ENVIRONMENT_LABEL_KEY } from 'src/common/consts/platformConfigConsts';
import { IFilterOptions } from 'src/common/helpers/DataFilterHelper';
import { QueryVariablesBuilder } from 'src/common/helpers/GQLRequestsHelper/QueryVariablesBuilder';
import {
	ConditionOperators,
	Wfa_Session_RunsSortFields,
	Wfa_Session_RunsSortOrder
} from 'src/common/types/graphql.generated';

import { DashboardWfaSessionsQueryVariables } from '../Sessions.generated';

const DAYS_AMOUNT_FILTER_PARAM_KEY = 'daysAmountFilter';

const sessionsSortFieldNamesMap: Record<string, Wfa_Session_RunsSortFields> = {
	sessionName: Wfa_Session_RunsSortFields.SessionName,
	runTime: Wfa_Session_RunsSortFields.RunTime,
	criticalIssues: Wfa_Session_RunsSortFields.CriticalIssues,
	totalIssues: Wfa_Session_RunsSortFields.TotalIssues,
	createdBy: Wfa_Session_RunsSortFields.UserName
};

const sessionsSortOrderMap: Record<SORT_ORDER, Wfa_Session_RunsSortOrder> = {
	[SORT_ORDER.ASC]: Wfa_Session_RunsSortOrder.Ascending,
	[SORT_ORDER.DESC]: Wfa_Session_RunsSortOrder.Descending
};

export const buildTestsQueryVariables = ({
	dateRange,
	pageSize,
	page,
	filterOptions,
	sort,
	labelsExcludedFromDashboard
}: IGetWebSdkTestsParams): DashboardWfaSessionsQueryVariables => {
	const variablesBuilder = new QueryVariablesBuilder<DashboardWfaSessionsQueryVariables>({
		sortFieldsMap: sessionsSortFieldNamesMap,
		sortOrderMap: sessionsSortOrderMap
	});

	variablesBuilder.addPaginationParams(page, pageSize).addSortParam(sort);

	const customFieldOptions = omit(filterOptions ?? {}, [ENVIRONMENT_LABEL_KEY]) as TFilterOptions;

	variablesBuilder.addTupleFilterParam(
		CUSTOM_FIELDS_FILTER_PARAM_KEY,
		customFieldOptions,
		ConditionOperators.All,
		true
	);

	variablesBuilder.addConditionParam(DAYS_AMOUNT_FILTER_PARAM_KEY, dateRange);

	if (labelsExcludedFromDashboard && Object.keys(labelsExcludedFromDashboard).length > 0) {
		variablesBuilder.addNeTupleFilterParam(
			'customFieldsFilterExcludes' as keyof DashboardWfaSessionsQueryVariables,
			labelsExcludedFromDashboard
		);
	}

	const variables = variablesBuilder.getVariables();
	const environmentConfig = buildEnvironmentFilters(filterOptions as IFilterOptions);

	return {
		...variables,
		...(environmentConfig?.customFieldsFilter && {
			environmentCustomFieldsFilter: environmentConfig.customFieldsFilter
		}),
		...(environmentConfig?.environmentsFilter && {
			environmentsFilter: environmentConfig.environmentsFilter
		})
	};
};
